module.exports = __webpack_public_path__ + "img/medalha-industria-comercio.6b95347c.png";